const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_YEARLY_INCOME(state, yearlyIncome) {
    state.yearlyIncome = yearlyIncome
  },
  UPDATE_OTHER_INCOME(state, otherIncome) {
    state.otherIncome = otherIncome
  },
  UPDATE_INCOME_TAX_NO(state, incomeTaxNo) {
    state.incomeTaxNo = incomeTaxNo
  },
  UPDATE_PENSION_NO(state, pensionNo) {
    state.pensionNo = pensionNo
  },
  UPDATE_EMPLOYMENT_STATUS(state, employmentStatus) {
    state.employmentStatus = employmentStatus
  },
  UPDATE_RETIREMENT_STATUS(state, retirementStatus) {
    state.retirementStatus = retirementStatus
  },
}

const actions = {
  updateYearlyIncome({
    commit
  }, yearlyIncome) {
    commit('UPDATE_YEARLY_INCOME', yearlyIncome);
  },
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateOtherIncome({
    commit
  }, otherIncome) {
    commit('UPDATE_OTHER_INCOME', otherIncome);
  },
  updateIncomeTaxNo({
    commit
  }, incomeTaxNo) {
    commit('UPDATE_INCOME_TAX_NO', incomeTaxNo);
  },
  updatePensionNo({
    commit
  }, pensionNo) {
    commit('UPDATE_PENSION_NO', pensionNo);
  },
  updateEmploymentStatus({
    commit
  }, employmentStatus) {
    commit('UPDATE_EMPLOYMENT_STATUS', employmentStatus);
  },
  updateRetirementStatus({
    commit
  }, retirementStatus) {
    commit('UPDATE_RETIREMENT_STATUS', retirementStatus);
  },
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  YearlyIncome: state => {
    return state.yearlyIncome
  },
  OtherIncome: state => {
    return state.otherIncome
  },
  IncomeTaxNo: state => {
    return state.incomeTaxNo
  },
  PensionNo: state => {
    return state.pensionNo
  },
  EmploymentStatus: state => {
    return state.employmentStatus
  },
  RetirementStatus: state => {
    return state.retirementStatus
  },
}

const employmentDetails = {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      yearlyIncome: 0,
      otherIncome: 0,
      incomeTaxNo: "",
      pensionNo: "",
      employmentStatus: 0,
      retirementStatus: 0
    }
  },
  getters,
  actions,
  mutations
}

export default employmentDetails
